// extracted by mini-css-extract-plugin
module.exports = {"loginLink":"LoginLink_loginLink__oOV0o","shimmer":"LoginLink_shimmer__5oiYQ"};